import HtmlEditor from './HtmlEditor.vue';

export default HtmlEditor;
